import React from "react";

const HistoryIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.369"
      height="23.959"
      viewBox="0 0 25.369 23.959"
    >
      <path
        id="db99"
        d="M218.9,214.968a12,12,0,0,0-11.836,10.218h-1.552l2.819,3.523,2.819-3.523h-1.96a9.849,9.849,0,1,1,1.211,6.793l-1.729,1.189a11.976,11.976,0,1,0,10.229-18.2Zm-3.523,13.741h5.285v-7.047h-2.114V226.6h-3.171"
        transform="translate(-205.513 -214.967)"
        fill={fill ? fill : "#0051bc"}
      />
    </svg>
  );
};

export default HistoryIcon;
